export const config = {
    version: '4.0.12'
};
